var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"icon-button",class:( _obj = {
    'opacity-60': _vm.disabled
  }, _obj[("bg-" + _vm.bgColor)] = _vm.bgColor, _obj ),attrs:{"type":_vm.type,"disabled":_vm.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_c('ui-icon',{attrs:{"name":_vm.name,"size":_vm.size,"width":_vm.width,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }